import { css } from '@emotion/react'

import Link from '@/components/common/Link'

import { mediaUp } from '@/styles/media'
import { colors } from '@/styles/theme'
import { Text2Styles } from '@/styles/typography'
import { focusVisible, underlineHover } from '@/styles/mixins'
import { City } from '@/service'

interface Props {
  fullWidth?: boolean
  cities?: City[]
}

function SearchHints(props: Props) {
  const { fullWidth = false, cities } = props

  return (
    <ul css={[hintsList, fullWidth && hintsListCentered]}>
      {cities?.map((el, idx) => (
        <li data-test-id={el.cityUrlSlug} css={hintsListItem} key={idx}>
          <Link
            href={{
              pathname: '/parkings/[city]',
              query: {
                city: el.cityUrlSlug
              }
            }}
            passHref
            prefetch={false}
          >
            <a css={hintsListItemLink}>{el.label}</a>
          </Link>
        </li>
      ))}
    </ul>
  )
}

const hintsList = css`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  margin: 9px 0 0;

  ${mediaUp('lg')} {
    margin: 20px 0 0;
  }
`

const hintsListCentered = css`
  justify-content: center;
`

const hintsListItem = css`
  position: relative;
  margin-inline-end: 20px;
  display: flex;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: calc(100% + 10px);
    transform: translate(0%, -50%);
    width: 2px;
    height: 2px;
    border-radius: 50%;
    background-color: ${colors.twilightBlue};

    html[lang^='ar'] & {
      right: calc(100% + 10px);
      left: unset;
    }
  }

  &:last-of-type {
    margin-inline-end: 0;

    &::after {
      content: none;
    }
  }
`

const hintsListItemLink = css`
  ${focusVisible};
  ${Text2Styles};
  ${underlineHover};
  color: ${colors.twilightBlue};
  line-height: 1.6;
`

export default SearchHints
